module.exports = __webpack_public_path__ + "static/media/resume.9afe2c99.pdf";